<template>
  <div class="collection-info-menu">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 mb-4">
          <h4 class="mb-3">
            <i class="bi bi-collection me-2"></i>
            収集情報設定
          </h4>
          <p class="text-muted">
            収集に関する各種設定を管理します。設定したい項目を選択してください。
          </p>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-lg-4 col-md-6" v-for="menu in menuItems" :key="menu.id">
          <BCard
            class="menu-card h-100 shadow-sm border-0"
            @click="navigateToSetting(menu.route)"
          >
            <div class="text-center">
              <div class="menu-icon mb-3">
                <i :class="menu.icon" class="text-primary" style="font-size: 2.5rem;"></i>
              </div>
              <h5 class="card-title mb-3">{{ menu.title }}</h5>
              <p class="card-text text-muted mb-4">{{ menu.description }}</p>
              <BButton
                variant="outline-primary"
                class="w-100"
                @click.stop="navigateToSetting(menu.route)"
              >
                <i class="bi bi-arrow-right me-2"></i>
                設定画面を開く
              </BButton>
            </div>
          </BCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { BCard, BButton } from 'bootstrap-vue-next'

const emit = defineEmits(['navigate-to-setting'])

const menuItems = [
  {
    id: 'municipal-organization',
    title: '自治体組織設定',
    description: '自治体の組織情報を管理します。',
    icon: 'bi bi-building',
    route: 'municipal-organization'
  },
  {
    id: 'collection-company',
    title: '収集企業設定',
    description: '収集業務を行う企業の情報を管理します。',
    icon: 'bi bi-truck',
    route: 'collection-company'
  },
  {
    id: 'waste-type',
    title: 'ごみ・かご種別設定',
    description: 'ごみやかごの種別を管理します。',
    icon: 'bi bi-recycle',
    route: 'waste-type'
  },
  {
    id: 'collection-district',
    title: '収集地区設定',
    description: '収集を行う地区を管理します。',
    icon: 'bi bi-geo-alt',
    route: 'collection-district'
  },
  {
    id: 'district-town',
    title: '地区町名設定',
    description: '各地区に含まれる町名を管理します。',
    icon: 'bi bi-signpost',
    route: 'district-town'
  },
  {
    id: 'collection-calendar',
    title: '収集カレンダー設定',
    description: '収集スケジュールを管理します。収集日や休日の設定を行います。',
    icon: 'bi bi-calendar-check',
    route: 'collection-calendar'
  }
]

const navigateToSetting = (route) => {
  emit('navigate-to-setting', route)
}
</script>

<style scoped>
.collection-info-menu {
  padding: 1.5rem 0;
}

.menu-card {
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.menu-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 123, 255, 0.15) !important;
  border-color: rgba(0, 123, 255, 0.2);
}

.menu-icon {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title {
  font-weight: 600;
  color: #2c3e50;
}

.card-text {
  font-size: 0.9rem;
  line-height: 1.5;
  min-height: 3rem;
}

.btn-outline-primary {
  border-width: 2px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.3);
}
</style>
